// File: frontend/src/i18n/practice.js
// Version: 1.0 (2026-10-16, Wave A Translation — Leads, Cases, Tasks, Intake)
// Description: Bilingual translation dictionary for Wave A practice components:
//              LeadsPage, LeadHistoryPage, CasesPage, CaseDetailPage, NewCasePage,
//              IntakeFormPage, TasksPage, TeamAssignmentModal.

const EN = {
    // ── Leads Page ───────────────────────────────────────────────────────────
    'practice.leads.title': 'Leads Management',
    'practice.leads.subtitle': 'Leads from Sofia phone calls and the web chat — review, manage, and convert.',
    'practice.leads.search_placeholder': 'Search by name, email, or phone...',
    'practice.leads.filter_all': 'All Statuses',
    'practice.leads.filter_new': 'NEW',
    'practice.leads.filter_contacted': 'CONTACTED',
    'practice.leads.filter_qualified': 'QUALIFIED',
    'practice.leads.filter_unqualified': 'UNQUALIFIED',
    'practice.leads.filter_converted': 'CONVERTED',
    'practice.leads.count_summary': '{filtered} of {total} leads',
    'practice.leads.col_name': 'Full Name',
    'practice.leads.col_email': 'Email',
    'practice.leads.col_phone': 'Phone',
    'practice.leads.col_source': 'Source',
    'practice.leads.col_status': 'Status',
    'practice.leads.col_date': 'Created At',
    'practice.leads.col_actions': 'Actions',
    'practice.leads.btn_view': 'View',
    'practice.leads.btn_edit': 'Edit',
    'practice.leads.btn_convert': 'Convert to Client',
    'practice.leads.btn_assign_team': 'Assign Team',
    'practice.leads.btn_delete': 'Delete',
    'practice.leads.btn_more_actions': 'More actions',
    'practice.leads.case_id_not_available': 'Case ID not available yet',
    'practice.leads.no_leads': 'No leads found.',
    'practice.leads.loading': 'Loading leads...',
    'practice.leads.delete_confirm': 'Delete lead "{name}"? This cannot be undone.',
    'practice.leads.delete_success': 'Lead "{name}" deleted.',
    'practice.leads.delete_failed': 'Failed to delete: {error}',
    'practice.leads.convert_success': 'Lead converted successfully!',
    'practice.leads.convert_failed': 'Conversion failed: {error}',
    'practice.leads.fetch_failed': 'Failed to fetch leads: {error}',
    'practice.leads.status_open': 'Open',
    'practice.leads.status_pending': 'Pending',
    'practice.leads.status_closed': 'Closed',

    // ── Lead Sources ──────────────────────────────────────────────────────────
    'practice.source.website': 'Website',
    'practice.source.phone_sofia': 'Phone (Sofia)',
    'practice.source.webchat_sofia': 'Web Chat (Sofia)',

    // ── Leads Preview Modal ──────────────────────────────────────────────────
    'practice.leads.modal_preview_title': 'Lead Details',
    'practice.leads.badge_new_activity': 'New activity',
    'practice.leads.modal_preview_fullname': 'Full Name:',
    'practice.leads.modal_preview_email': 'Email:',
    'practice.leads.modal_preview_phone': 'Phone:',
    'practice.leads.modal_preview_source': 'Source:',
    'practice.leads.modal_preview_status': 'Status:',
    'practice.leads.modal_preview_created': 'Created At:',
    'practice.leads.modal_preview_notes': 'Notes:',
    'practice.leads.modal_preview_not_provided': 'Not provided',
    'practice.leads.modal_preview_scheduled_consultation': 'Scheduled Consultation',
    'practice.leads.modal_preview_datetime': 'Date & Time:',
    'practice.leads.modal_preview_calendar_link': 'Calendar Link:',
    'practice.leads.modal_preview_view_gcal': 'View Google Event',
    'practice.leads.modal_preview_close': 'Close',

    // ── Leads Edit Modal ─────────────────────────────────────────────────────
    'practice.leads.modal_edit_title': 'Edit Lead',
    'practice.leads.modal_edit_cancel': 'Cancel',
    'practice.leads.modal_edit_save': 'Save Changes',
    'practice.leads.modal_edit_saving': 'Saving...',
    'practice.leads.modal_edit_success': 'Lead updated successfully.',
    'practice.leads.modal_edit_failed': 'Failed to update lead: {error}',

    // ── Team Assignment Modal ─────────────────────────────────────────────────
    'practice.leads.team_modal_title': 'Assign Team to Case: {caseName}',
    'practice.leads.team_modal_no_staff': 'No Attorneys or Paralegals found. Please add staff members first.',
    'practice.leads.team_modal_attorney': 'Attorney',
    'practice.leads.team_modal_paralegal': 'Paralegal',
    'practice.leads.team_modal_select_attorney': '-- Select Attorney --',
    'practice.leads.team_modal_select_paralegal': '-- Select Paralegal --',
    'practice.leads.team_modal_no_attorneys': 'No Attorneys available',
    'practice.leads.team_modal_no_paralegals': 'No Paralegals available',
    'practice.leads.team_modal_btn_cancel': 'Cancel',
    'practice.leads.team_modal_btn_assign': 'Assign Team',
    'practice.leads.team_modal_assigning': 'Assigning...',
    'practice.leads.team_modal_success': 'Team assigned to case {caseName} successfully!',
    'practice.leads.team_modal_failed': 'Assignment failed: {error}',
    'practice.leads.team_modal_select_attorney_req': 'Please select an Attorney.',
    'practice.leads.team_modal_select_paralegal_req': 'Please select a Paralegal.',
    'practice.leads.team_modal_load_failed': 'Failed to load staff: {error}',
    'practice.leads.team_modal_loading_staff': 'Loading staff...',

    // ── Lead History / Detail Page ───────────────────────────────────────────
    'practice.lead_history.back': '← Back',
    'practice.lead_history.title_fallback': 'Inquiry #{id}',
    'practice.lead_history.inquiry_num': 'Inquiry #{id}',
    'practice.lead_history.cases_count': ' · {count} cases',
    'practice.lead_history.no_cases': ' · no cases yet',
    'practice.lead_history.btn_edit': 'Edit',
    'practice.lead_history.btn_convert': '⚡ Convert to Case',
    'practice.lead_history.btn_convert_title': 'Creates client account and new case in 1 click',
    'practice.lead_history.btn_open_case': '📂 Open Case #{id} →',
    'practice.lead_history.btn_delete': 'Delete',
    'practice.lead_history.convert_confirm_msg': 'Convert "{name}" to client?\n\nWHAT WILL HAPPEN IMMEDIATELY:\n• a client account will be created;\n• a new legal case will be opened automatically;\n• an email with portal access will be sent to {email}.\n\nCreate client and open case?',
    'practice.lead_history.unknown_email': 'address unknown — email may not be sent',
    'practice.lead_history.convert_toast_opening': 'Opening created case #{id}...',
    'practice.lead_history.convert_success': 'Lead converted to client and case created!',
    'practice.lead_history.convert_failed': 'Conversion failed: {error}',
    'practice.lead_history.delete_confirm_msg': 'Delete inquiry "{name}"?\n\nDeletion is SOFT: the row remains in the database along with the feed, messages, and calls, and simply disappears from display.\n\n🔴 THERE IS NO RESTORE SCREEN IN THE INTERFACE. You will NOT be able to restore the inquiry yourself — only via an administrator.',
    'practice.lead_history.delete_success': 'Inquiry "{name}" deleted.',
    'practice.lead_history.delete_failed': 'Failed to delete: {error}',

    // ── History Timeline Component ───────────────────────────────────────────
    'practice.history.title': 'History',
    'practice.history.no_events': 'no touchpoints recorded yet',
    'practice.history.events_count': '{count} entries',
    'practice.history.readiness_label': 'Filing Readiness',
    'practice.history.readiness_unmeasured_hint': 'Reconciliation has not been run. A dash is not zero percent.',
    'practice.history.empty_timeline': 'No touchpoints in the feed. This means there are no records in the database, not that there was no communication.',
    'practice.history.loading': 'Loading history...',
    'practice.history.error': 'Failed to load history: {error}',
    'practice.history.attached': 'Attached: {pct}',
    'practice.history.risk': 'Risk: {risk}',
    'practice.history.ready_for_filing': 'Ready for filing: {ready}',
    'practice.history.yes': 'yes',
    'practice.history.no': 'no',
    'practice.history.last_action_label': 'Last action:',

    // ── History Event Types ──────────────────────────────────────────────────
    'practice.history_event.lead_created': 'Lead created',
    'practice.history_event.call_received': 'Call',
    'practice.history_event.sms_message': 'SMS',
    'practice.history_event.email_received': 'Email',
    'practice.history_event.document_uploaded': 'Document',
    'practice.history_event.case_created': 'Case opened',
    'practice.history_event.task_created': 'Task',
    'practice.history_event.task_completed': 'Task completed',
    'practice.history_event.team_assigned': 'Team assignment',
    'practice.history_event.question_asked': 'Question',
    'practice.history_event.decision_made': 'Decision',
    'practice.history_event.checklist_verified': 'Reconciliation',

    // ── Cases Page ───────────────────────────────────────────────────────────
    'practice.cases.title': 'Case Management',
    'practice.cases.subtitle': 'Cases, their clients and current status.',
    'practice.cases.btn_new_case': 'New Case',
    'practice.cases.search_case_number': 'Case Number',
    'practice.cases.search_case_number_ph': 'e.g., EP-2026-000001',
    'practice.cases.search_client_last_name': 'Client Last Name',
    'practice.cases.search_client_last_name_ph': 'e.g., Smith',
    'practice.cases.btn_reset': 'Reset',
    'practice.cases.btn_search': 'Search',
    'practice.cases.loading': 'Loading cases...',
    'practice.cases.col_case_number': 'Case Number',
    'practice.cases.col_title': 'Title',
    'practice.cases.col_client': 'Client',
    'practice.cases.col_status': 'Status',
    'practice.cases.col_created': 'Created At',
    'practice.cases.col_actions': 'Actions',
    'practice.cases.no_cases': 'No cases found.',
    'practice.cases.delete_confirm': 'Are you sure you want to delete case {caseNumber}? This cannot be undone.',
    'practice.cases.delete_success': 'Case {caseNumber} deleted',
    'practice.cases.delete_failed': 'Failed to delete case',
    'practice.cases.status_open': 'Open',
    'practice.cases.status_in_progress': 'In Progress',
    'practice.cases.status_pending': 'Pending',
    'practice.cases.status_closed': 'Closed',

    // ── Case Detail Page ─────────────────────────────────────────────────────
    'practice.case_detail.title': 'Case Details: {caseNumber}',
    'practice.case_detail.section_info': 'Case Information',
    'practice.case_detail.field_case_number': 'Case Number:',
    'practice.case_detail.field_status': 'Status:',
    'practice.case_detail.field_case_type': 'Case Type:',
    'practice.case_detail.field_client': 'Client:',
    'practice.case_detail.field_attorney': 'Assigned Attorney:',
    'practice.case_detail.field_paralegal': 'Assigned Paralegal:',
    'practice.case_detail.field_created': 'Created On:',
    'practice.case_detail.field_description': 'Description',
    'practice.case_detail.no_description': 'No description provided.',
    'practice.case_detail.unassigned': 'Unassigned',
    'practice.case_detail.not_found_title': 'Case Not Found',
    'practice.case_detail.not_found_desc': 'The requested case could not be found or you don\'t have permission to view it.',
    'practice.case_detail.back_to_list': 'Back to Cases List',
    'practice.case_detail.assign_team_header': 'Assign Team',
    'practice.case_detail.select_attorney': 'Assigned Attorney',
    'practice.case_detail.select_paralegal': 'Assigned Paralegal',
    'practice.case_detail.unassigned_option': '-- Unassigned --',
    'practice.case_detail.btn_save_assignments': 'Save Assignments',
    'practice.case_detail.saving_assignments': 'Saving assignments...',
    'practice.case_detail.assignments_updated': 'Team assignments updated!',
    'practice.case_detail.assignments_failed': 'Failed to update assignments: {error}',
    'practice.case_detail.history_header': 'Assignment History',
    'practice.case_detail.no_history': 'No assignment changes recorded yet.',
    'practice.case_detail.loading_history': 'Loading history...',
    'practice.case_detail.loading_case': 'Loading case data...',
    'practice.case_detail.status_updated': 'Case status updated to {status}',
    'practice.case_detail.status_failed': 'Failed to update case status',
    'practice.case_detail.deadline_block_title': 'Case Deadline',
    'practice.case_detail.deadline_save': 'Save',
    'practice.case_detail.deadline_reason_ph': 'Reason label',
    'practice.case_detail.deadline_current': 'Current: {status}',
    'practice.case_detail.by': 'by',
    'practice.case_detail.related_tasks': 'Related Tasks ({count})',
    'practice.case_detail.loading_tasks': 'Loading tasks...',
    'practice.case_detail.no_tasks': 'No tasks linked to this case.',
    'practice.case_detail.due': ' · Due {date}',
    'practice.case_detail.status_open': 'Open',
    'practice.case_detail.status_in_progress': 'In Progress',
    'practice.case_detail.status_pending': 'Pending',
    'practice.case_detail.status_closed': 'Closed',

    // ── New Case Page ────────────────────────────────────────────────────────
    'practice.new_case.title': 'Create a New Case',
    'practice.new_case.subtitle': 'Enter client and case details below. If the client\'s email is new, a profile will be created automatically.',
    'practice.new_case.section_client': 'Client Information',
    'practice.new_case.email': 'Client Email',
    'practice.new_case.email_or_phone_required': '(Email or Phone required)',
    'practice.new_case.email_ph': 'e.g., client@example.com',
    'practice.new_case.first_name': 'First Name',
    'practice.new_case.first_name_ph': 'Client\'s first name',
    'practice.new_case.last_name': 'Last Name',
    'practice.new_case.last_name_ph': 'Client\'s last name',
    'practice.new_case.phone': 'Phone Number',
    'practice.new_case.phone_ph': 'e.g., +12125551234',
    'practice.new_case.section_case': 'Case Details',
    'practice.new_case.case_type': 'Case Type',
    'practice.new_case.case_subtype': 'Case Subtype',
    'practice.new_case.case_title': 'Case Title',
    'practice.new_case.case_title_ph': 'e.g., Green card through employment',
    'practice.new_case.description': 'Description',
    'practice.new_case.description_ph': 'Add any initial notes or details...',
    'practice.new_case.select_subtype': '-- Select Subtype --',
    'practice.new_case.btn_cancel': 'Cancel',
    'practice.new_case.btn_create': 'Create Case',
    'practice.new_case.creating': 'Creating new case and client (if needed)...',
    'practice.new_case.validation_email_or_phone': 'Client Email or Phone Number is required.',
    'practice.new_case.validation_title': 'Case Title is required.',
    'practice.new_case.success': 'New case created successfully! Case Number: {caseNumber}',
    'practice.new_case.failed': 'Failed to create case: {error}',
    'practice.new_case.default_client_first_name': 'Client',
    'practice.new_case.subtype_investor': 'Investor Visas (E-2, EB-5)',
    'practice.new_case.subtype_employment': 'Employment-Based Visas (L-1, O-1, H-1B)',
    'practice.new_case.subtype_family': 'Family-Based Green Cards',
    'practice.new_case.subtype_fiance': 'Fiancé(e) Visas (K-1)',
    'practice.new_case.subtype_adjustment': 'Adjustment of Status',
    'practice.new_case.subtype_naturalization': 'Naturalization & Citizenship',

    // ── Intake Form Page ─────────────────────────────────────────────────────
    'practice.intake.title': 'Intake Form for Case #{caseId}',
    'practice.intake.percent_complete': '{percent}% Complete',
    'practice.intake.no_questions': 'No questions found for this case type.',
    'practice.intake.btn_previous': 'Previous',
    'practice.intake.btn_save_next': 'Save and Next',
    'practice.intake.btn_finish_analyze': 'Finish & Analyze Case',
    'practice.intake.saving': 'Saving...',
    'practice.intake.loading': 'Loading Form...',
    'practice.intake.modal_title': 'Confirm Submission',
    'practice.intake.modal_body': 'Are you sure you want to finalize and submit this case for AI analysis? This action cannot be undone.',
    'practice.intake.modal_cancel': 'Cancel',
    'practice.intake.modal_confirm': 'Confirm & Analyze',
    'practice.intake.modal_analyzing': 'Analyzing...',
    'practice.intake.load_failed': 'Failed to load intake form data. Redirecting...',
    'practice.intake.save_failed': 'Failed to save responses.',
    'practice.intake.finalize_failed': 'Failed to start case analysis.',
    'practice.intake.analysis_started': 'Case analysis started. Redirecting to Case Details...',

    // ── Tasks Page ───────────────────────────────────────────────────────────
    'practice.tasks.title': 'Task Center',
    'practice.tasks.subtitle': 'Manage case work and AI action items',
    'practice.tasks.btn_new_task': 'New Task',
    'practice.tasks.ai_suggestions_title': 'AI Suggestions',
    'practice.tasks.ai_suggestions_subtitle': 'The AI has identified potential action items from recent case files.',
    'practice.tasks.col_todo': 'To Do',
    'practice.tasks.col_in_progress': 'In Progress',
    'practice.tasks.col_review': 'Review',
    'practice.tasks.col_done': 'Done',
    'practice.tasks.search_placeholder': 'Search tasks...',
    'practice.tasks.table_col_task': 'Task',
    'practice.tasks.table_col_status': 'Status',
    'practice.tasks.table_col_priority': 'Priority',
    'practice.tasks.table_col_due_date': 'Due Date',
    'practice.tasks.table_col_actions': 'Actions',
    'practice.tasks.priority_urgent': 'URGENT',
    'practice.tasks.priority_high': 'HIGH',
    'practice.tasks.priority_medium': 'MEDIUM',
    'practice.tasks.priority_low': 'LOW',
    'practice.tasks.status_todo': 'TODO',
    'practice.tasks.status_in_progress': 'IN_PROGRESS',
    'practice.tasks.status_review': 'REVIEW',
    'practice.tasks.status_done': 'DONE',
    'practice.tasks.loading': 'Loading tasks...',
    'practice.tasks.created_toast': 'Task Created',
    'practice.tasks.creation_failed': 'Creation failed',
    'practice.tasks.status_moved_toast': 'Moved to {status}',
    'practice.tasks.status_update_failed': 'Failed to update status',
    'practice.tasks.fetch_failed': 'Failed to load tasks',
    'practice.tasks.task_detail_title': 'Task Detail Page (Placeholder)',
    'practice.tasks.task_detail_subtitle': 'This page will show the details of a specific task.',

    // ── History Page & Event States (Wave B) ──────────────────────────────────
    'practice.history_state.izvesten': 'Deadline set',
    'practice.history_state.priznan_neizvestnym': 'Unknown for now',
    'practice.history_state.ne_sprashivali': 'Deadline cleared',
    'practice.history_state.pismo_otpravleno': 'Sent',
    'practice.history_state.vopros_v_ocheredi': 'Queued',
    'practice.history.feed_firm_title': 'History',
    'practice.history.feed_firm_desc': 'Firmwide feed: calls, emails, SMS, documents, cases, tasks, questions and decisions, newest first.',
    'practice.history.feed_lead_desc': 'Calls, emails, SMS, documents, cases, tasks, questions and decisions for one person{name}.',
    'practice.history.back_to_work': '← Back to work',
    'practice.history.search_placeholder': 'Name, phone, email, or keyword from event',
    'practice.history.all_firm': 'All firm',
    'practice.history.all_filter': 'All ({count})',
    'practice.history.deny_title': 'Firm feed is restricted to firm staff. Your account does not have access permissions — this is a permission rejection, not an absence of events.',
    'practice.history.open_consilium': 'Open {name} →',
    'practice.history.search_dual_hint': 'Search spans two scopes at once: {leads_count} most recent leads from the list, and {events_count} feed events — their titles and descriptions{trunc}. Email body text is never stored in the feed — emails are searched by SUBJECT, not full thread.',
    'practice.history.search_truncated': '. Feed is TRUNCATED by server limit ({limit}): more events exist in the database than displayed',
    'practice.history.leads_error': '🔴 Could not query lead names: {error}. Search by person is currently unavailable — this is a query error, not \'no leads\'. Feed events search ({count}) works as usual.',
    'practice.history.people_empty': 'No matches found among loaded leads. This applies to loaded records, not the entire firm.',
    'practice.history.loading_feed': 'Loading feed…',
    'practice.history.access_denied': 'Access to feed denied: {error}. This is a permission rejection, not an empty feed.',
    'practice.history.feed_error': 'Failed to load feed: {error}. Events may exist — we could not fetch them, this is not zero.',
    'practice.history.empty_feed': 'No events in feed. No records found in database — this does not mean there was no communication.',
    'practice.history.unknown_types': 'Types without dictionary: {count} ({types}). Their cards are displayed, but source is unrecognized.',
    'practice.history.today': 'Today, {date}',
    'practice.history.yesterday': 'Yesterday, {date}',
    'practice.history.card_collapse': 'Collapse',
    'practice.history.card_expand': 'Expand',
    'practice.history.ask_katifi': 'Ask {name} about this event',
    'practice.history.citation_loading': 'Requesting source…',
    'practice.history.citation_denied': 'Access denied: source quotation is available to firm staff. This is a denial, not an empty source.',
    'practice.history.citation_not_found': 'Server states no event exists with this ID. It is visible on screen — feed and database are out of sync.',
    'practice.history.citation_lost': 'Source row is LOST: event exists, but source itself does not.',
    'practice.history.citation_failed': 'Could NOT query source: {error}. This is an inquiry failure, not an empty source.',
    'practice.history.citation_truncated': 'Showing first {limit} characters — source contains more text.',

    // ── Documents Page (Wave B) ──────────────────────────────────────────────
    'practice.docs.title': 'Document Management',
    'practice.docs.upload_section': 'Upload New Document',
    'practice.docs.upload_btn': 'Upload',
    'practice.docs.uploading': 'Uploading...',
    'practice.docs.loading': 'Loading documents...',
    'practice.docs.uploaded_on': 'Uploaded on: {date}',
    'practice.docs.no_docs': 'No documents found. Upload your first document to get started.',
    'practice.docs.summary_generating': 'Summary is being generated...',
    'practice.docs.select_file_prompt': 'Please select a file to upload.',
    'practice.docs.upload_success': 'Document uploaded successfully!',
    'practice.docs.upload_failed': 'Upload failed: {error}',
    'practice.docs.fetch_failed': 'Failed to fetch documents: {error}',

    // ── Document Generator Page (Wave B) ─────────────────────────────────────
    'practice.docgen.title': 'Document Generator',
    'practice.docgen.subtitle': 'Select a template and case to generate a pre-filled legal document.',
    'practice.docgen.generate_heading': 'Generate Document',
    'practice.docgen.template_label': 'Template',
    'practice.docgen.template_placeholder': '— Select a template —',
    'practice.docgen.case_label': 'Case',
    'practice.docgen.case_placeholder': '— Select a case —',
    'practice.docgen.no_templates': 'No templates available. Contact your administrator.',
    'practice.docgen.generate_btn': 'Generate Document',
    'practice.docgen.generating': 'Generating...',
    'practice.docgen.doc_id': 'Document ID:',
    'practice.docgen.status': 'Status:',
    'practice.docgen.finalized': 'Finalized',
    'practice.docgen.draft': 'Draft',
    'practice.docgen.generated_heading': 'Generated Document',
    'practice.docgen.save_draft': 'Save Draft',
    'practice.docgen.finalize_pdf': 'Finalize & Export PDF',
    'practice.docgen.saving': 'Saving...',
    'practice.docgen.empty_editor': 'Choose a template and case on the left, then click Generate Document to preview and edit the document here.',
    'practice.docgen.loading': 'Loading document templates…',
    'practice.docgen.select_both_prompt': 'Please select both a template and a case.',
    'practice.docgen.generated_success': 'Document generated successfully.',
    'practice.docgen.generate_failed': 'Failed to generate document. Please try again.',
    'practice.docgen.saved_success': 'Document saved successfully.',
    'practice.docgen.save_failed': 'Failed to save document.',
    'practice.docgen.finalized_toast': 'Document finalized. Opening PDF...',
    'practice.docgen.finalize_failed': 'Failed to finalize or export document.',
    'practice.docgen.load_failed': 'Failed to load templates or cases.',

    // ── Client Portal Page (Wave B) ──────────────────────────────────────────
    'practice.portal.title': 'Client Portal',
    'practice.portal.subtitle': 'Track case progress, view documents, and communicate with your legal team.',
    'practice.portal.cases_heading': 'Your Cases',
    'practice.portal.no_cases': 'No cases found for your account.',
    'practice.portal.tab_timeline': 'Timeline',
    'practice.portal.tab_documents': 'Documents',
    'practice.portal.tab_messages': 'Messages',
    'practice.portal.no_timeline': 'No timeline events recorded yet.',
    'practice.portal.no_documents': 'No documents attached to this case.',
    'practice.portal.upload_document': 'Upload Document',
    'practice.portal.upload_btn': 'Upload',
    'practice.portal.messages_heading': 'Direct Messages',
    'practice.portal.no_messages': 'No messages yet. Send a message to your legal team below.',
    'practice.portal.send_placeholder': 'Type a message...',
    'practice.portal.send_btn': 'Send',
    'practice.portal.loading': 'Loading client portal…',
    'practice.portal.opened_date': 'Opened {date}',
    'practice.portal.status_open': 'Open',
    'practice.portal.status_in_progress': 'In progress',
    'practice.portal.status_closed': 'Closed',
    'practice.portal.upload_success': 'Document uploaded successfully!',
    'practice.portal.upload_failed': 'Upload failed: {error}',
    'practice.portal.message_failed': 'Failed to send message: {error}',
    'practice.portal.select_file_prompt': 'Please select a file to upload.',
    'practice.portal.download': 'Download',
    'practice.portal.type_message_placeholder': 'Type a secure message to your attorney...',
    'practice.portal.select_case_prompt': 'Select a case to view details',
    'practice.portal.select_case_sub': 'Review case timeline, official documents, and communicate directly with your legal team.',
    'practice.portal.loading_messages': 'Loading encrypted messages…',
    'practice.portal.failed_load_messages': 'Failed to load messages.',
    'practice.portal.failed_load_cases': 'Failed to load your cases. Please refresh the page.',

    // ── Client Profile Page (Wave B) ─────────────────────────────────────────
    'practice.client.back': 'Back',
    'practice.client.loading': 'Loading client profile...',
    'practice.client.not_found': 'Client not found.',
    'practice.client.edit_profile': 'Edit Profile',
    'practice.client.details': 'Client Details',
    'practice.client.contact_info': 'Contact Information',
    'practice.client.email': 'Email',
    'practice.client.phone': 'Phone',
    'practice.client.address': 'Address',
    'practice.client.timezone': 'Timezone',
    'practice.client.active_cases': 'Active Cases',
    'practice.client.no_cases': 'No active cases.',
    'practice.client.timeline': 'Case Timeline',
    'practice.client.tasks': 'Tasks',
    'practice.client.no_tasks': 'No tasks found for this client.',
    'practice.client.modal_title': 'Edit Client Profile',
    'practice.client.first_name': 'First Name',
    'practice.client.last_name': 'Last Name',
    'practice.client.save_changes': 'Save Changes',
    'practice.client.cancel': 'Cancel',
    'practice.client.saving': 'Saving...',
    'practice.client.update_success': 'Client profile updated successfully',
    'practice.client.update_failed': 'Failed to update client profile',
    'practice.client.fetch_failed': 'Failed to fetch client data',
    'practice.client.case_number': 'Case Number:',
    'practice.client.status': 'Status:',
    'practice.client.created_at': 'Created At:',
    'practice.client.assigned_attorney': 'Assigned Attorney:',
    'practice.client.message': 'Message',
    'practice.client.case_title': 'Case Title',
    'practice.client.action': 'Action',
    'practice.client.view': 'View',
    'practice.client.role_client': 'Client',
    'practice.client.no_phone': 'No phone',
    'practice.client.no_address': 'Address not set',
    'practice.client.error_loading': 'Error Loading Profile',
    'practice.client.reason': 'Reason: {error}',
    'practice.client.go_back': 'Go Back',
    'practice.client.no_email_toast': 'Client has no email address',
    'practice.client.address_placeholder': 'Full Address',

    // ── Settings / User Profile (Task T3 Screen 8) ───────────────────────────
    'practice.profile.kicker': 'Settings',
    'practice.profile.title': 'User Profile',
    'practice.profile.subtitle': 'Manage your personal settings and integrations.',
    'practice.profile.active': 'Active',
    'practice.profile.inactive': 'Inactive',
    'practice.profile.personal_info': 'Personal Information',
    'practice.profile.full_name': 'Full Name',
    'practice.profile.email': 'Email',
    'practice.profile.role': 'Role',
    'practice.profile.integrations': 'Integrations',
    'practice.profile.google_calendar': 'Google Calendar',
    'practice.profile.sync_calendar_general': 'Sync appointments and consultations.',
    'practice.profile.sync_calendar_paralegal': 'Sync appointments with AI Paralegal.',
    'practice.profile.connected_as': 'Connected as {email}',
    'practice.profile.connect': 'Connect',
    'practice.profile.connecting': 'Connecting...',
    'practice.profile.disconnect': 'Disconnect',
    'practice.profile.disconnecting': 'Disconnecting...',
    'practice.profile.loading': 'Loading profile…',
    'practice.profile.not_found': 'User not found.',
    'practice.profile.ai_persona_title': 'AI Assistant Persona',
    'practice.profile.ai_persona_desc': 'Customize how your personal AI Assistant speaks to you in direct messages (Global Chat Widget).',
    'practice.profile.persona_colleague': 'Colleague (Professional & Respectful)',
    'practice.profile.persona_friend': 'Friend (Casual & Warm)',
    'practice.profile.persona_close_friend': 'Close Friend (Empathetic & Very Open)',
    'practice.profile.persona_romantic': 'Romantic (Flirtatious & Devoted)',
    'practice.profile.role_user': 'User',
    'practice.profile.toast_redirecting_google': 'Redirecting to Google...',
    'practice.profile.toast_google_success': 'Google Calendar successfully connected!',
    'practice.profile.toast_google_error': 'Connection failed: {detail}',
    'practice.profile.unknown_error': 'Unknown error',
    'practice.profile.error_no_auth_url': 'No authorization URL received.',
    'practice.profile.toast_error': 'Error: {error}',
    'practice.profile.confirm_disconnect_google': 'Disconnect Google Calendar?',
    'practice.profile.toast_disconnecting': 'Disconnecting...',
    'practice.profile.toast_disconnect_success': 'Disconnected successfully.',
    'practice.profile.toast_failed': 'Failed: {error}',
    'practice.profile.toast_updating_persona': 'Updating AI Assistant Persona...',
    'practice.profile.toast_persona_updated': 'Persona updated successfully.',

    // ── Login Page (Task T3 Screen 9) ─────────────────────────────────────────
    'practice.login.title': 'Welcome to {company}',
    'practice.login.subtitle': 'Professional Legal Management System',
    'practice.login.fitenko_title': 'Secure Client Portal',
    'practice.login.fitenko_subtitle': 'Sign in to access your immigration case files and case management tools.',
    'practice.login.email_label': 'Email Address',
    'practice.login.email_placeholder': 'Enter your email',
    'practice.login.password_label': 'Password',
    'practice.login.password_placeholder': 'Enter your password',
    'practice.login.signin': 'Sign In',
    'practice.login.signin_continue': 'Sign In to Continue',
    'practice.login.signing_in': 'Signing In…',
    'practice.login.toast_signing_in': 'Signing in...',
    'practice.login.toast_success': 'Login Successful!',
    'practice.login.toast_error': 'Login failed. Please check your credentials.',
};

const RU = {
    // ── Leads Page ───────────────────────────────────────────────────────────
    'practice.leads.title': 'Управление обращениями',
    'practice.leads.subtitle': 'Обращения из звонков Софии и чата на сайте — просмотр, управление и перевод в дела.',
    'practice.leads.search_placeholder': 'Поиск по имени, почте или телефону...',
    'practice.leads.filter_all': 'Все статусы',
    'practice.leads.filter_new': 'НОВЫЙ',
    'practice.leads.filter_contacted': 'СВЯЗАЛИСЬ',
    'practice.leads.filter_qualified': 'КВАЛИФИЦИРОВАН',
    'practice.leads.filter_unqualified': 'НЕ КВАЛИФИЦИРОВАН',
    'practice.leads.filter_converted': 'В КЛИЕНТАХ',
    'practice.leads.count_summary': '{filtered} из {total} обращений',
    'practice.leads.col_name': 'Имя',
    'practice.leads.col_email': 'Почта',
    'practice.leads.col_phone': 'Телефон',
    'practice.leads.col_source': 'Источник',
    'practice.leads.col_status': 'Статус',
    'practice.leads.col_date': 'Дата создания',
    'practice.leads.col_actions': 'Действия',
    'practice.leads.btn_view': 'Просмотр',
    'practice.leads.btn_edit': 'Изменить',
    'practice.leads.btn_convert': 'Перевести в клиенты',
    'practice.leads.btn_assign_team': 'Назначить команду',
    'practice.leads.btn_delete': 'Удалить',
    'practice.leads.btn_more_actions': 'Ещё действия',
    'practice.leads.case_id_not_available': 'Дело ещё не открыто',
    'practice.leads.no_leads': 'Обращений не найдено.',
    'practice.leads.loading': 'Загрузка обращений...',
    'practice.leads.delete_confirm': 'Удалить обращение «{name}»? Это действие нельзя отменить.',
    'practice.leads.delete_success': 'Обращение «{name}» удалено.',
    'practice.leads.delete_failed': 'Не удалось удалить: {error}',
    'practice.leads.convert_success': 'Обращение успешно переведено в клиенты!',
    'practice.leads.convert_failed': 'Перевод не удался: {error}',
    'practice.leads.fetch_failed': 'Не удалось загрузить обращения: {error}',
    'practice.leads.status_open': 'Открыто',
    'practice.leads.status_pending': 'В ожидании',
    'practice.leads.status_closed': 'Закрыто',

    // ── Lead Sources ──────────────────────────────────────────────────────────
    'practice.source.website': 'Сайт',
    'practice.source.phone_sofia': 'Звонок (Sofia)',
    'practice.source.webchat_sofia': 'Чат (Sofia)',

    // ── Leads Preview Modal ──────────────────────────────────────────────────
    'practice.leads.modal_preview_title': 'Карточка обращения',
    'practice.leads.badge_new_activity': 'Новое событие',
    'practice.leads.modal_preview_fullname': 'Имя:',
    'practice.leads.modal_preview_email': 'Почта:',
    'practice.leads.modal_preview_phone': 'Телефон:',
    'practice.leads.modal_preview_source': 'Источник:',
    'practice.leads.modal_preview_status': 'Статус:',
    'practice.leads.modal_preview_created': 'Дата создания:',
    'practice.leads.modal_preview_notes': 'Заметки:',
    'practice.leads.modal_preview_not_provided': 'Не указан',
    'practice.leads.modal_preview_scheduled_consultation': 'Запланированная консультация',
    'practice.leads.modal_preview_datetime': 'Дата и время:',
    'practice.leads.modal_preview_calendar_link': 'Ссылка на календарь:',
    'practice.leads.modal_preview_view_gcal': 'Открыть в Google Календаре',
    'practice.leads.modal_preview_close': 'Закрыть',

    // ── Leads Edit Modal ─────────────────────────────────────────────────────
    'practice.leads.modal_edit_title': 'Редактировать обращение',
    'practice.leads.modal_edit_cancel': 'Отмена',
    'practice.leads.modal_edit_save': 'Сохранить изменения',
    'practice.leads.modal_edit_saving': 'Сохранение...',
    'practice.leads.modal_edit_success': 'Обращение успешно обновлено.',
    'practice.leads.modal_edit_failed': 'Не удалось обновить обращение: {error}',

    // ── Team Assignment Modal ─────────────────────────────────────────────────
    'practice.leads.team_modal_title': 'Назначить команду для дела: {caseName}',
    'practice.leads.team_modal_no_staff': 'Сотрудники не найдены. Сначала добавьте сотрудников в систему.',
    'practice.leads.team_modal_attorney': 'Адвокат',
    'practice.leads.team_modal_paralegal': 'Помощник юриста',
    'practice.leads.team_modal_select_attorney': '-- Выберите адвоката --',
    'practice.leads.team_modal_select_paralegal': '-- Выберите помощника юриста --',
    'practice.leads.team_modal_no_attorneys': 'Нет доступных адвокатов',
    'practice.leads.team_modal_no_paralegals': 'Нет доступных помощников юриста',
    'practice.leads.team_modal_btn_cancel': 'Отмена',
    'practice.leads.team_modal_btn_assign': 'Назначить команду',
    'practice.leads.team_modal_assigning': 'Назначение...',
    'practice.leads.team_modal_success': 'Команда успешно назначена на дело {caseName}!',
    'practice.leads.team_modal_failed': 'Не удалось назначить команду: {error}',
    'practice.leads.team_modal_select_attorney_req': 'Пожалуйста, выберите адвоката.',
    'practice.leads.team_modal_select_paralegal_req': 'Пожалуйста, выберите помощника юриста.',
    'practice.leads.team_modal_load_failed': 'Не удалось загрузить сотрудников: {error}',
    'practice.leads.team_modal_loading_staff': 'Загрузка сотрудников...',

    // ── Lead History / Detail Page ───────────────────────────────────────────
    'practice.lead_history.back': '← Назад',
    'practice.lead_history.title_fallback': 'Обращение №{id}',
    'practice.lead_history.inquiry_num': 'Обращение №{id}',
    'practice.lead_history.cases_count': ' · дел: {count}',
    'practice.lead_history.no_cases': ' · дела ещё нет',
    'practice.lead_history.btn_edit': 'Изменить',
    'practice.lead_history.btn_convert': '⚡ Перевести в дело',
    'practice.lead_history.btn_convert_title': 'Создаст учетную запись и новое дело в 1 клик',
    'practice.lead_history.btn_open_case': '📂 Открыть дело №{id} →',
    'practice.lead_history.btn_delete': 'Удалить',
    'practice.lead_history.convert_confirm_msg': 'Перевести «{name}» в клиенты?\n\nЧТО ПРОИЗОЙДЁТ СЕЙЧАС ЖЕ:\n• будет создана учётная запись клиента;\n• будет автоматически заведено новое юридическое дело;\n• на адрес {email} уйдёт письмо с доступом в портал.\n\nСоздать клиента и открыть дело?',
    'practice.lead_history.unknown_email': 'адрес не известен — письмо может не уйти',
    'practice.lead_history.convert_toast_opening': 'Открываю созданное дело №{id}...',
    'practice.lead_history.convert_success': 'Обращение переведено в клиенты и заведено дело!',
    'practice.lead_history.convert_failed': 'Перевести не удалось: {error}',
    'practice.lead_history.delete_confirm_msg': 'Удалить обращение «{name}»?\n\nУдаление МЯГКОЕ: строка остаётся в базе вместе с лентой, сообщениями\nи звонками, и с показа она просто исчезает.\n\n🔴 НО ЭКРАНА ВОССТАНОВЛЕНИЯ В ИНТЕРФЕЙСЕ НЕТ. Вернуть обращение\nсамостоятельно вы НЕ СМОЖЕТЕ — только через администратора.',
    'practice.lead_history.delete_success': 'Обращение «{name}» удалено.',
    'practice.lead_history.delete_failed': 'Удалить не удалось: {error}',

    // ── History Timeline Component ───────────────────────────────────────────
    'practice.history.title': 'История',
    'practice.history.no_events': 'касаний пока не записано',
    'practice.history.events_count': '{count} записей',
    'practice.history.readiness_label': 'Готовность к подаче',
    'practice.history.readiness_unmeasured_hint': 'Сверка не запускалась ни разу. Прочерк — это не ноль процентов.',
    'practice.history.empty_timeline': 'Ни одного касания в ленте. Это значит, что записей нет в базе, — а не что с человеком не общались.',
    'practice.history.loading': 'Загружаю историю…',
    'practice.history.error': 'История не загрузилась: {error}',
    'practice.history.attached': 'Приложено: {pct}',
    'practice.history.risk': 'Риск: {risk}',
    'practice.history.ready_for_filing': 'К подаче: {ready}',
    'practice.history.yes': 'да',
    'practice.history.no': 'нет',
    'practice.history.last_action_label': 'Последнее действие:',

    // ── History Event Types ──────────────────────────────────────────────────
    'practice.history_event.lead_created': 'Обращение',
    'practice.history_event.call_received': 'Звонок',
    'practice.history_event.sms_message': 'СМС',
    'practice.history_event.email_received': 'Письмо',
    'practice.history_event.document_uploaded': 'Документ',
    'practice.history_event.case_created': 'Дело заведено',
    'practice.history_event.task_created': 'Задача',
    'practice.history_event.task_completed': 'Задача закрыта',
    'practice.history_event.team_assigned': 'Назначение',
    'practice.history_event.question_asked': 'Вопрос',
    'practice.history_event.decision_made': 'Решение',
    'practice.history_event.checklist_verified': 'Сверка',

    // ── Cases Page ───────────────────────────────────────────────────────────
    'practice.cases.title': 'Управление делами',
    'practice.cases.subtitle': 'Юридические дела, клиенты и их текущий статус.',
    'practice.cases.btn_new_case': 'Новое дело',
    'practice.cases.search_case_number': 'Номер дела',
    'practice.cases.search_case_number_ph': 'например, EP-2026-000001',
    'practice.cases.search_client_last_name': 'Фамилия клиента',
    'practice.cases.search_client_last_name_ph': 'например, Смирнов',
    'practice.cases.btn_reset': 'Сбросить',
    'practice.cases.btn_search': 'Искать',
    'practice.cases.loading': 'Загрузка дел...',
    'practice.cases.col_case_number': 'Номер дела',
    'practice.cases.col_title': 'Название',
    'practice.cases.col_client': 'Клиент',
    'practice.cases.col_status': 'Статус',
    'practice.cases.col_created': 'Дата создания',
    'practice.cases.col_actions': 'Действия',
    'practice.cases.no_cases': 'Дел не найдено.',
    'practice.cases.delete_confirm': 'Вы уверены, что хотите удалить дело {caseNumber}? Это действие нельзя отменить.',
    'practice.cases.delete_success': 'Дело {caseNumber} удалено',
    'practice.cases.delete_failed': 'Не удалось удалить дело',
    'practice.cases.status_open': 'Открыто',
    'practice.cases.status_in_progress': 'В работе',
    'practice.cases.status_pending': 'В ожидании',
    'practice.cases.status_closed': 'Закрыто',

    // ── Case Detail Page ─────────────────────────────────────────────────────
    'practice.case_detail.title': 'Карточка дела: {caseNumber}',
    'practice.case_detail.section_info': 'Информация о деле',
    'practice.case_detail.field_case_number': 'Номер дела:',
    'practice.case_detail.field_status': 'Статус:',
    'practice.case_detail.field_case_type': 'Тип дела:',
    'practice.case_detail.field_client': 'Клиент:',
    'practice.case_detail.field_attorney': 'Назначенный юрист:',
    'practice.case_detail.field_paralegal': 'Назначенный помощник:',
    'practice.case_detail.field_created': 'Дата открытия:',
    'practice.case_detail.field_description': 'Описание',
    'practice.case_detail.no_description': 'Описание не заполнено.',
    'practice.case_detail.unassigned': 'Не назначен',
    'practice.case_detail.not_found_title': 'Дело не найдено',
    'practice.case_detail.not_found_desc': 'Запрошенное дело не найдено или у вас нет прав на его просмотр.',
    'practice.case_detail.back_to_list': 'Вернуться к списку дел',
    'practice.case_detail.assign_team_header': 'Назначение команды',
    'practice.case_detail.select_attorney': 'Ведущий юрист',
    'practice.case_detail.select_paralegal': 'Помощник юриста',
    'practice.case_detail.unassigned_option': '-- Не назначен --',
    'practice.case_detail.btn_save_assignments': 'Сохранить назначения',
    'practice.case_detail.saving_assignments': 'Сохранение назначений...',
    'practice.case_detail.assignments_updated': 'Команда дела успешно обновлена!',
    'practice.case_detail.assignments_failed': 'Не удалось обновить назначения: {error}',
    'practice.case_detail.history_header': 'История назначений',
    'practice.case_detail.no_history': 'Изменений назначений пока нет.',
    'practice.case_detail.loading_history': 'Загрузка истории...',
    'practice.case_detail.loading_case': 'Загрузка данных дела...',
    'practice.case_detail.status_updated': 'Статус дела изменен на {status}',
    'practice.case_detail.status_failed': 'Не удалось обновить статус дела',
    'practice.case_detail.deadline_block_title': 'Срок по делу',
    'practice.case_detail.deadline_save': 'Сохранить',
    'practice.case_detail.deadline_reason_ph': 'Подпись-причина',
    'practice.case_detail.deadline_current': 'Сейчас: {status}',
    'practice.case_detail.by': 'пользователем',
    'practice.case_detail.related_tasks': 'Связанные задачи ({count})',
    'practice.case_detail.loading_tasks': 'Загрузка задач...',
    'practice.case_detail.no_tasks': 'Нет задач, привязанных к этому делу.',
    'practice.case_detail.due': ' · Срок {date}',
    'practice.case_detail.status_open': 'Открыто',
    'practice.case_detail.status_in_progress': 'В работе',
    'practice.case_detail.status_pending': 'В ожидании',
    'practice.case_detail.status_closed': 'Закрыто',

    // ── New Case Page ────────────────────────────────────────────────────────
    'practice.new_case.title': 'Создать новое дело',
    'practice.new_case.subtitle': 'Введите данные клиента и дела. Если почта новая, профиль клиента создастся автоматически.',
    'practice.new_case.section_client': 'Информация о клиенте',
    'practice.new_case.email': 'Электронная почта клиента',
    'practice.new_case.email_or_phone_required': '(Требуется почта или телефон)',
    'practice.new_case.email_ph': 'например, client@example.com',
    'practice.new_case.first_name': 'Имя',
    'practice.new_case.first_name_ph': 'Имя клиента',
    'practice.new_case.last_name': 'Фамилия',
    'practice.new_case.last_name_ph': 'Фамилия клиента',
    'practice.new_case.phone': 'Номер телефона',
    'practice.new_case.phone_ph': 'например, +12125551234',
    'practice.new_case.section_case': 'Детали дела',
    'practice.new_case.case_type': 'Тип дела',
    'practice.new_case.case_subtype': 'Подтип дела',
    'practice.new_case.case_title': 'Название дела',
    'practice.new_case.case_title_ph': 'например, Грин-карта через работодателя',
    'practice.new_case.description': 'Описание',
    'practice.new_case.description_ph': 'Добавьте начальные сведения или заметки...',
    'practice.new_case.select_subtype': '-- Выберите подтип --',
    'practice.new_case.btn_cancel': 'Отмена',
    'practice.new_case.btn_create': 'Создать дело',
    'practice.new_case.creating': 'Создание нового дела и клиента (если нужно)...',
    'practice.new_case.validation_email_or_phone': 'Требуется указать почту или номер телефона клиента.',
    'practice.new_case.validation_title': 'Название дела обязательно для заполнения.',
    'practice.new_case.success': 'Новое дело успешно создано! Номер дела: {caseNumber}',
    'practice.new_case.failed': 'Не удалось создать дело: {error}',
    'practice.new_case.default_client_first_name': 'Клиент',
    'practice.new_case.subtype_investor': 'Инвесторские визы (E-2, EB-5)',
    'practice.new_case.subtype_employment': 'Рабочие визы (L-1, O-1, H-1B)',
    'practice.new_case.subtype_family': 'Семейные грин-карты',
    'practice.new_case.subtype_fiance': 'Визы жениха/невесты (K-1)',
    'practice.new_case.subtype_adjustment': 'Смена статуса (Adjustment of Status)',
    'practice.new_case.subtype_naturalization': 'Натурализация и гражданство',

    // ── Intake Form Page ─────────────────────────────────────────────────────
    'practice.intake.title': 'Опросный лист по делу #{caseId}',
    'practice.intake.percent_complete': 'Заполнено: {percent}%',
    'practice.intake.no_questions': 'Вопросы для этого типа дела не найдены.',
    'practice.intake.btn_previous': 'Назад',
    'practice.intake.btn_save_next': 'Сохранить и далее',
    'practice.intake.btn_finish_analyze': 'Завершить и передать ИИ',
    'practice.intake.saving': 'Сохранение...',
    'practice.intake.loading': 'Загрузка формы...',
    'practice.intake.modal_title': 'Подтверждение отправки',
    'practice.intake.modal_body': 'Вы уверены, что хотите завершить опрос и передать дело на ИИ-анализ? Это действие нельзя отменить.',
    'practice.intake.modal_cancel': 'Отмена',
    'practice.intake.modal_confirm': 'Подтвердить и передать',
    'practice.intake.modal_analyzing': 'Анализ...',
    'practice.intake.load_failed': 'Не удалось загрузить данные опросного листа. Перенаправление...',
    'practice.intake.save_failed': 'Не удалось сохранить ответы.',
    'practice.intake.finalize_failed': 'Не удалось запустить анализ дела.',
    'practice.intake.analysis_started': 'Анализ дела запущен. Переход в карточку дела...',

    // ── Tasks Page ───────────────────────────────────────────────────────────
    'practice.tasks.title': 'Центр задач',
    'practice.tasks.subtitle': 'Управление задачами по делам и действиями ИИ',
    'practice.tasks.btn_new_task': 'Новая задача',
    'practice.tasks.ai_suggestions_title': 'Рекомендации ИИ',
    'practice.tasks.ai_suggestions_subtitle': 'ИИ выявил возможные задачи на основе последних материалов дел.',
    'practice.tasks.col_todo': 'К выполнению',
    'practice.tasks.col_in_progress': 'В работе',
    'practice.tasks.col_review': 'На проверке',
    'practice.tasks.col_done': 'Завершено',
    'practice.tasks.search_placeholder': 'Поиск задач...',
    'practice.tasks.table_col_task': 'Задача',
    'practice.tasks.table_col_status': 'Статус',
    'practice.tasks.table_col_priority': 'Приоритет',
    'practice.tasks.table_col_due_date': 'Срок',
    'practice.tasks.table_col_actions': 'Действия',
    'practice.tasks.priority_urgent': 'СРОЧНО',
    'practice.tasks.priority_high': 'ВЫСОКИЙ',
    'practice.tasks.priority_medium': 'СРЕДНИЙ',
    'practice.tasks.priority_low': 'НИЗКИЙ',
    'practice.tasks.status_todo': 'К ВЫПОЛНЕНИЮ',
    'practice.tasks.status_in_progress': 'В РАБОТЕ',
    'practice.tasks.status_review': 'НА ПРОВЕРКЕ',
    'practice.tasks.status_done': 'ЗАВЕРШЕНО',
    'practice.tasks.loading': 'Загрузка задач...',
    'practice.tasks.created_toast': 'Задача создана',
    'practice.tasks.creation_failed': 'Ошибка создания задачи',
    'practice.tasks.status_moved_toast': 'Перемещено в «{status}»',
    'practice.tasks.status_update_failed': 'Не удалось обновить статус',
    'practice.tasks.fetch_failed': 'Не удалось загрузить задачи',
    'practice.tasks.task_detail_title': 'Детали задачи (Заглушка)',
    'practice.tasks.task_detail_subtitle': 'На этой странице будут отображаться подробности выбранной задачи.',

    // ── History Page & Event States (Wave B) ──────────────────────────────────
    'practice.history_state.izvesten': 'Срок есть',
    'practice.history_state.priznan_neizvestnym': 'Пока неизвестен',
    'practice.history_state.ne_sprashivali': 'Срок снят',
    'practice.history_state.pismo_otpravleno': 'Отправлено',
    'practice.history_state.vopros_v_ocheredi': 'В очереди',
    'practice.history.feed_firm_title': 'История',
    'practice.history.feed_firm_desc': 'Лента всей фирмы: звонки, письма, СМС, документы, дела, задачи, вопросы и решения, новые сверху.',
    'practice.history.feed_lead_desc': 'Звонки, письма, СМС, документы, дела, задачи, вопросы и решения одного человека{name}.',
    'practice.history.back_to_work': '← Назад к работе',
    'practice.history.search_placeholder': 'Имя, телефон, почта или слово из события',
    'practice.history.all_firm': 'Вся фирма',
    'practice.history.all_filter': 'Всё ({count})',
    'practice.history.deny_title': 'Лента фирмы доступна сотрудникам фирмы. Ваша учётная запись прав на неё не имеет — это отказ, а не отсутствие событий.',
    'practice.history.open_consilium': 'Открыть {name} →',
    'practice.history.search_dual_hint': 'Поиск идёт по двум охватам сразу: по {leads_count} последним обращениям, которые отдала ручка списка, и по {events_count} событиям ленты — их заголовкам и описаниям{trunc}. Тело письма в ленту не попадает никогда — по письмам ищется ТЕМА, а не переписка.',
    'practice.history.search_truncated': '. Лента УСЕЧЕНА пределом сервера ({limit}): событий в базе больше, чем показано',
    'practice.history.leads_error': '🔴 Имена обращений спросить НЕ УДАЛОСЬ: {error}. Поиск по людям сейчас не работает — это отказ измерителя, а не «обращений нет». По событиям ленты ({count}) поиск идёт как обычно.',
    'practice.history.people_empty': 'Среди загруженных обращений совпадений нет. Это про загруженные, а не про всю фирму.',
    'practice.history.loading_feed': 'Загружаю ленту…',
    'practice.history.access_denied': 'Отказано в доступе к ленте: {error}. Это отказ по правам, а не пустая лента.',
    'practice.history.feed_error': 'Лента не загрузилась: {error}. Событий может быть сколько угодно — мы их не получили, и это не ноль.',
    'practice.history.empty_feed': 'Ни одного события в ленте. Записей нет в базе — это не значит, что общения не было.',
    'practice.history.unknown_types': 'Типов без словаря: {count} ({types}). Их карточки на месте, а источник у них не опознан.',
    'practice.history.today': 'Сегодня, {date}',
    'practice.history.yesterday': 'Вчера, {date}',
    'practice.history.card_collapse': 'Свернуть',
    'practice.history.card_expand': 'Раскрыть',
    'practice.history.ask_katifi': 'Спросить {name} об этом событии',
    'practice.history.citation_loading': 'Запрашиваю источник…',
    'practice.history.citation_denied': 'Отказано по правам: цитата источника доступна сотрудникам фирмы. Это отказ, а не пустой источник.',
    'practice.history.citation_not_found': 'Сервер говорит, что события с таким номером нет. На экране оно есть — значит лента и база разошлись.',
    'practice.history.citation_lost': 'Строка-источник УТРАЧЕНА: событие о ней есть, а её самой нет.',
    'practice.history.citation_failed': 'Источник спросить НЕ УДАЛОСЬ: {error}. Это отказ измерителя, а не пустой источник.',
    'practice.history.citation_truncated': 'Показано первые {limit} символов — в источнике текста больше.',

    // ── Documents Page (Wave B) ──────────────────────────────────────────────
    'practice.docs.title': 'Управление документами',
    'practice.docs.upload_section': 'Загрузить новый документ',
    'practice.docs.upload_btn': 'Загрузить',
    'practice.docs.uploading': 'Загрузка...',
    'practice.docs.loading': 'Загрузка документов...',
    'practice.docs.uploaded_on': 'Загружено: {date}',
    'practice.docs.no_docs': 'Документы не найдены. Загрузите первый документ для начала работы.',
    'practice.docs.summary_generating': 'Аннотация создается...',
    'practice.docs.select_file_prompt': 'Пожалуйста, выберите файл для загрузки.',
    'practice.docs.upload_success': 'Документ успешно загружен!',
    'practice.docs.upload_failed': 'Ошибка загрузки: {error}',
    'practice.docs.fetch_failed': 'Не удалось получить документы: {error}',

    // ── Document Generator Page (Wave B) ─────────────────────────────────────
    'practice.docgen.title': 'Генератор документов',
    'practice.docgen.subtitle': 'Выберите шаблон и дело для создания предзаполненного юридического документа.',
    'practice.docgen.generate_heading': 'Создать документ',
    'practice.docgen.template_label': 'Шаблон',
    'practice.docgen.template_placeholder': '— Выберите шаблон —',
    'practice.docgen.case_label': 'Дело',
    'practice.docgen.case_placeholder': '— Выберите дело —',
    'practice.docgen.no_templates': 'Шаблоны недоступны. Обратитесь к администратору.',
    'practice.docgen.generate_btn': 'Создать документ',
    'practice.docgen.generating': 'Создание...',
    'practice.docgen.doc_id': 'ID документа:',
    'practice.docgen.status': 'Статус:',
    'practice.docgen.finalized': 'Утвержден',
    'practice.docgen.draft': 'Черновик',
    'practice.docgen.generated_heading': 'Созданный документ',
    'practice.docgen.save_draft': 'Сохранить черновик',
    'practice.docgen.finalize_pdf': 'Утвердить и экспортировать PDF',
    'practice.docgen.saving': 'Сохранение...',
    'practice.docgen.empty_editor': 'Выберите шаблон и дело слева, затем нажмите «Создать документ» для предпросмотра и редактирования.',
    'practice.docgen.loading': 'Загрузка шаблонов документов…',
    'practice.docgen.select_both_prompt': 'Пожалуйста, выберите и шаблон, и дело.',
    'practice.docgen.generated_success': 'Документ успешно создан.',
    'practice.docgen.generate_failed': 'Не удалось создать документ. Попробуйте снова.',
    'practice.docgen.saved_success': 'Документ успешно сохранен.',
    'practice.docgen.save_failed': 'Не удалось сохранить документ.',
    'practice.docgen.finalized_toast': 'Документ утвержден. Открываем PDF...',
    'practice.docgen.finalize_failed': 'Не удалось утвердить или экспортировать документ.',
    'practice.docgen.load_failed': 'Не удалось загрузить шаблоны или дела.',

    // ── Client Portal Page (Wave B) ──────────────────────────────────────────
    'practice.portal.title': 'Портал клиента',
    'practice.portal.subtitle': 'Отслеживайте ход дела, просматривайте документы и общайтесь с юридической командой.',
    'practice.portal.cases_heading': 'Ваши дела',
    'practice.portal.no_cases': 'Дела для вашей учетной записи не найдены.',
    'practice.portal.tab_timeline': 'Хроника',
    'practice.portal.tab_documents': 'Документы',
    'practice.portal.tab_messages': 'Сообщения',
    'practice.portal.no_timeline': 'События хроники еще не записаны.',
    'practice.portal.no_documents': 'К этому делу не прикреплено документов.',
    'practice.portal.upload_document': 'Загрузить документ',
    'practice.portal.upload_btn': 'Загрузить',
    'practice.portal.messages_heading': 'Прямые сообщения',
    'practice.portal.no_messages': 'Сообщений пока нет. Отправьте сообщение вашей юридической команде ниже.',
    'practice.portal.send_placeholder': 'Введите сообщение...',
    'practice.portal.send_btn': 'Отправить',
    'practice.portal.loading': 'Загрузка портала клиента…',
    'practice.portal.opened_date': 'Открыто {date}',
    'practice.portal.status_open': 'Открыто',
    'practice.portal.status_in_progress': 'В работе',
    'practice.portal.status_closed': 'Закрыто',
    'practice.portal.upload_success': 'Документ успешно загружен!',
    'practice.portal.upload_failed': 'Ошибка загрузки: {error}',
    'practice.portal.message_failed': 'Не удалось отправить сообщение: {error}',
    'practice.portal.select_file_prompt': 'Пожалуйста, выберите файл для загрузки.',
    'practice.portal.download': 'Скачать',
    'practice.portal.type_message_placeholder': 'Напишите защищенное сообщение вашему юристу...',
    'practice.portal.select_case_prompt': 'Выберите дело для просмотра деталей',
    'practice.portal.select_case_sub': 'Просматривайте хронику дела, официальные документы и общайтесь с юридической командой.',
    'practice.portal.loading_messages': 'Загрузка сообщений…',
    'practice.portal.failed_load_messages': 'Не удалось загрузить сообщения.',
    'practice.portal.failed_load_cases': 'Не удалось загрузить ваши дела. Пожалуйста, обновите страницу.',

    // ── Client Profile Page (Wave B) ─────────────────────────────────────────
    'practice.client.back': 'Назад',
    'practice.client.loading': 'Загрузка профиля клиента...',
    'practice.client.not_found': 'Клиент не найден.',
    'practice.client.edit_profile': 'Редактировать профиль',
    'practice.client.details': 'Данные клиента',
    'practice.client.contact_info': 'Контактная информация',
    'practice.client.email': 'Эл. почта',
    'practice.client.phone': 'Телефон',
    'practice.client.address': 'Адрес',
    'practice.client.timezone': 'Часовой пояс',
    'practice.client.active_cases': 'Активные дела',
    'practice.client.no_cases': 'Нет активных дел.',
    'practice.client.timeline': 'Хронология дела',
    'practice.client.tasks': 'Задачи',
    'practice.client.no_tasks': 'Задачи по клиенту не найдены.',
    'practice.client.modal_title': 'Редактировать профиль клиента',
    'practice.client.first_name': 'Имя',
    'practice.client.last_name': 'Фамилия',
    'practice.client.save_changes': 'Сохранить изменения',
    'practice.client.cancel': 'Отмена',
    'practice.client.saving': 'Сохранение...',
    'practice.client.update_success': 'Профиль клиента успешно обновлен',
    'practice.client.update_failed': 'Не удалось обновить профиль клиента',
    'practice.client.fetch_failed': 'Не удалось загрузить данные клиента',
    'practice.client.case_number': 'Номер дела:',
    'practice.client.status': 'Статус:',
    'practice.client.created_at': 'Создано:',
    'practice.client.assigned_attorney': 'Назначенный юрист:',
    'practice.client.message': 'Написать',
    'practice.client.case_title': 'Название дела',
    'practice.client.action': 'Действие',
    'practice.client.view': 'Просмотр',
    'practice.client.role_client': 'Клиент',
    'practice.client.no_phone': 'Нет телефона',
    'practice.client.no_address': 'Адрес не указан',
    'practice.client.error_loading': 'Ошибка загрузки профиля',
    'practice.client.reason': 'Причина: {error}',
    'practice.client.go_back': 'Назад',
    'practice.client.no_email_toast': 'У клиента нет адреса эл. почты',
    'practice.client.address_placeholder': 'Полный адрес',

    // ── Settings / User Profile (Task T3 Screen 8) ───────────────────────────
    'practice.profile.kicker': 'Настройки',
    'practice.profile.title': 'Профиль пользователя',
    'practice.profile.subtitle': 'Управление личными данными и интеграциями.',
    'practice.profile.active': 'Активен',
    'practice.profile.inactive': 'Неактивен',
    'practice.profile.personal_info': 'Личные данные',
    'practice.profile.full_name': 'ФИО',
    'practice.profile.email': 'Почта',
    'practice.profile.role': 'Роль',
    'practice.profile.integrations': 'Интеграции',
    'practice.profile.google_calendar': 'Google Календарь',
    'practice.profile.sync_calendar_general': 'Синхронизация встреч и консультаций.',
    'practice.profile.sync_calendar_paralegal': 'Синхронизация встреч с AI Paralegal.',
    'practice.profile.connected_as': 'Подключено как {email}',
    'practice.profile.connect': 'Подключить',
    'practice.profile.connecting': 'Подключение...',
    'practice.profile.disconnect': 'Отключить',
    'practice.profile.disconnecting': 'Отключение...',
    'practice.profile.loading': 'Загрузка профиля…',
    'practice.profile.not_found': 'Пользователь не найден.',
    'practice.profile.ai_persona_title': 'Персона AI-ассистента',
    'practice.profile.ai_persona_desc': 'Настройте, как персональный AI-ассистент общается с вами в прямых сообщениях (виджет чата).',
    'practice.profile.persona_colleague': 'Коллега (деловой и уважительный)',
    'practice.profile.persona_friend': 'Друг (неформальный и тёплый)',
    'practice.profile.persona_close_friend': 'Близкий друг (чуткий и открытый)',
    'practice.profile.persona_romantic': 'Романтик (флиртующий и преданный)',
    'practice.profile.role_user': 'Пользователь',
    'practice.profile.toast_redirecting_google': 'Перенаправление в Google...',
    'practice.profile.toast_google_success': 'Google Календарь успешно подключён!',
    'practice.profile.toast_google_error': 'Ошибка подключения: {detail}',
    'practice.profile.unknown_error': 'Неизвестная ошибка',
    'practice.profile.error_no_auth_url': 'Ссылка авторизации не получена.',
    'practice.profile.toast_error': 'Ошибка: {error}',
    'practice.profile.confirm_disconnect_google': 'Отключить Google Календарь?',
    'practice.profile.toast_disconnecting': 'Отключение...',
    'practice.profile.toast_disconnect_success': 'Успешно отключено.',
    'practice.profile.toast_failed': 'Не удалось: {error}',
    'practice.profile.toast_updating_persona': 'Обновление персоны AI-ассистента...',
    'practice.profile.toast_persona_updated': 'Персона успешно обновлена.',

    // ── Login Page (Task T3 Screen 9) ─────────────────────────────────────────
    'practice.login.title': 'Вход в {company}',
    'practice.login.subtitle': 'Профессиональная юридическая система управления',
    'practice.login.fitenko_title': 'Безопасный портал клиента',
    'practice.login.fitenko_subtitle': 'Войдите для доступа к иммиграционным делам и инструментам управления.',
    'practice.login.email_label': 'Адрес электронной почты',
    'practice.login.email_placeholder': 'Введите ваш email',
    'practice.login.password_label': 'Пароль',
    'practice.login.password_placeholder': 'Введите ваш пароль',
    'practice.login.signin': 'Войти',
    'practice.login.signin_continue': 'Войти для продолжения',
    'practice.login.signing_in': 'Вход…',
    'practice.login.toast_signing_in': 'Выполняется вход...',
    'practice.login.toast_success': 'Вход выполнен успешно!',
    'practice.login.toast_error': 'Не удалось войти. Пожалуйста, проверьте введённые данные.',
};

export const SLOVAR = Object.freeze({
    en: Object.freeze(EN),
    ru: Object.freeze(RU),
});

export function perevesti(lang, key, vars) {
    const yazyk = lang === 'ru' ? 'ru' : 'en';
    const slovar = SLOVAR[yazyk];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) {
        return `[${key}]`;
    }
    const shablon = slovar[key];
    if (!vars || typeof vars !== 'object') return shablon;
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(vars, imya) && vars[imya] !== undefined && vars[imya] !== null
            ? String(vars[imya])
            : celoe
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
